// extracted by mini-css-extract-plugin
export var root = "BreakingDownBarriersBlock-module--root--YCAjo";
export var container = "BreakingDownBarriersBlock-module--container--2CiDp";
export var title = "BreakingDownBarriersBlock-module--title--1g4sh";
export var listItems = "BreakingDownBarriersBlock-module--listItems--MmNpw";
export var listItem = "BreakingDownBarriersBlock-module--listItem--1G6nt";
export var contentTitle = "BreakingDownBarriersBlock-module--content-title--F_umj";
export var content = "BreakingDownBarriersBlock-module--content--3OYy7";